var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',{staticClass:"smart-tbody"},_vm._l((_vm.requestData),function(row,id){return _c('tr',{class:_vm.loadStatus(row)},[_vm._l((_vm.labels),function(col,index){return _c('td',{key:index,class:_vm.GetClass(col),on:{"click":function($event){_vm.clickInTd(col, row)}}},[(col.two == undefined)?_c('span',[(col.icon != undefined)?_c('i',{class:col.icon}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(col.css != undefined ? col.css : ''),attrs:{"title":_vm.strip_tags(_vm.text_processor(col.data, row))},domProps:{"innerHTML":_vm._s(_vm.text_processor(col.data, row))}})]):_c('span',{staticClass:"two-lines"},[_c('b',{class:{
						iconed:
							col.icon != undefined &&
							(typeof col.icon == 'string' ||
								col.icon[0] != undefined),
					}},[(
							col.icon != undefined &&
							typeof col.icon == 'string'
						)?_c('i',{class:col.icon}):(
							col.icon != undefined &&
							col.icon[0] != undefined
						)?_c('i',{class:col.icon[0]}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(col.css != undefined ? col.css : ''),attrs:{"title":_vm.strip_tags(_vm.text_processor(col.data, row))},domProps:{"innerHTML":_vm._s(_vm.text_processor(col.data[0], row))}})]),_vm._v(" "),_c('small',{class:{
						iconed:
							col.icon != undefined &&
							(typeof col.icon == 'string' ||
								col.icon[1] != undefined),
					}},[(
							col.icon != undefined &&
							typeof col.icon == 'string'
						)?_c('i',{class:col.icon}):(
							col.icon != undefined &&
							col.icon[1] != undefined
						)?_c('i',{class:col.icon[1]}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"text",style:(col.css != undefined ? col.css : ''),attrs:{"title":_vm.strip_tags(_vm.text_processor(col.data, row))},domProps:{"innerHTML":_vm._s(_vm.text_processor(col.data[1], row))}})])])])}),_vm._v(" "),_c('table-actions',{attrs:{"actions":_vm.actions,"row":row},on:{"customAction":function($event){_vm.$emit('customAction', $event)}}})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-960f5eee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app-components/table/tbody.vue
// module id = null
// module chunks = 